import type { Setter } from "solid-js";
import { useApi, useChannels } from "@/api";
import type { Menu } from "@/app/context";

export function useContextMenu(setMenu: Setter<Menu | null>) {
	const channels2 = useChannels();
	const store = useApi();

	const handleContextMenu = (e: MouseEvent) => {
		console.log("[menu] open context menu");
		const targetEl = e.target as HTMLElement;

		const menuEl = targetEl.closest(
			".menu-room, .menu-channel, .menu-thread, .menu-message, .menu-user, .menu-calendar-event",
		) as HTMLElement | null;
		const mediaEl = targetEl.closest(
			"a:not(.nav), img:not(.avatar), video, audio",
		) as HTMLElement | null;
		console.log("[menu] target elements", { menuEl, mediaEl, targetEl });
		if (!menuEl) return;
		if (mediaEl && mediaEl !== menuEl) return;

		const getData = (key: string) => {
			const target = menuEl.closest(`[${key}]`) as HTMLElement | null;
			return target?.dataset[
				key
					.slice("data-".length)
					.replace(/-([a-z])/g, (_, c) => c.toUpperCase())
			];
		};

		let menu: Partial<Menu> | null = null;
		const room_id = getData("data-room-id");
		const thread_id = getData("data-channel-id") ?? getData("data-thread-id");
		const message_id = getData("data-message-id");
		const user_id = getData("data-user-id");
		console.log("[menu] menu id data", {
			room_id,
			thread_id,
			message_id,
			user_id,
		});

		if (menuEl.classList.contains("menu-room")) {
			if (!room_id) return;
			menu = {
				type: "room",
				room_id,
			};
		} else if (
			menuEl.classList.contains("menu-channel") ||
			menuEl.classList.contains("menu-thread")
		) {
			if (!thread_id) return;
			menu = {
				type: "channel",
				channel_id: thread_id,
			};
		} else if (menuEl.classList.contains("menu-message")) {
			const message = store.messages.cache.get(message_id!);
			if (!message) return;
			const channel_id = (message as any).channel_id;
			const version_id =
				(message as any).latest_version?.version_id ??
				(message as any).version_id;
			menu = {
				type: "message",
				channel_id,
				message_id,
				version_id: (version_id as string) || undefined,
			};
		} else if (menuEl.classList.contains("menu-user")) {
			if (!user_id) return;
			const thread = channels2.cache.get(thread_id!);
			const room = store.rooms.cache.get(room_id!);
			if (thread?.room_id && room?.id && thread.room_id !== room.id) {
				console.warn("mismatched thread/room ids!");
			}

			menu = {
				type: "user",
				channel_id: thread?.id,
				room_id: thread?.room_id ?? room?.id ?? undefined,
				user_id,
			};
		} else if (menuEl.classList.contains("menu-calendar-event")) {
			const event_id = getData("data-event-id");
			const channel_id = getData("data-channel-id");
			if (!event_id || !channel_id) return;
			const event = store.calendar.cache.get(event_id);
			if (!event) return;
			menu = {
				type: "calendar_event",
				channel_id,
				event,
				anchor: menuEl,
			};
		}

		if (menu) {
			console.log("[menu] resolved menu", menu);
			e.preventDefault();
			e.stopPropagation();
			setMenu({
				x: e.clientX,
				y: e.clientY,
				...menu,
			} as Menu);
		} else {
			console.log("[menu] no resolved menu");
		}
	};

	return { handleContextMenu };
}
